import React from "react";
import "./index.css"; 
import u55 from '../../assets/icons/u55.png'



  class Momey extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
        }
    }

    componentDidMount(){
       
    }

    render() {
        const { data } = this.props;
        console.log('data:',data);
        return (
            <div className="wrapper-box" style={{maxWidth:1920}}>
                <img src={u55} alt='' />
            </div>
        )
    }
}

export default Momey

  

  
